import React, { useState } from 'react';

const SearchBar = ({ keyword, onSubmit }) => {
  const [state, setState] = useState({ keyword });

  //console.log('SearchBar', keyword);

  // useEffect(() => {

  // })

  return (
    <div id='searchBar' className="search-bar ui segment">
      <form className="ui form" onSubmit={e => {
        e.preventDefault();
        onSubmit(state.keyword, null);
      }}>
        <div className="field">
          <label>대한사랑 영상 검색</label>
          <input type='text' value={state.keyword} onChange={e => setState({ keyword: e.target.value })} />
        </div>
      </form>
    </div>
  )
}

// class SearchBar extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = { term: '' };
//   }

//   render() {
//     return (
//       <div className="search-bar ui segment">
//         <form className="ui form" onSubmit={e => {
//           e.preventDefault();
//           this.props.onSubmit(this.state.term);
//         }}>
//           <div className="field">
//             <label>Video Search</label>
//             <input
//               type='text'
//               value={this.state.term}
//               onChange={e => this.setState({ term: e.target.value })}
//             />
//           </div>
//         </form>
//       </div>
//     );
//   }
// }

export default SearchBar;

